import { ColorControlType, copyColorData } from "./color";
import { copyImageData, ImageControlType } from "./image";
import { copyLinkData, LinkControlType } from "./link";
import {
  copyListData,
  ListControlType,
  getListTranslatableData,
  mergeListTranslatedData
} from "./list";
import {
  copyShapeData,
  ShapeControlType,
  getShapeTranslatableData,
  mergeShapeTranslatedData
} from "./shape";
import { TextAreaControlType } from "./text-area";
import {
  TextInputControlType
} from "./text-input";
import { copyStyleData, StyleControlType } from "./style";
import {
  copySlotData,
  mergeSlotControlTranslatedData,
  mergeSlotData,
  SlotControlType
} from "./slot";
import {
  Types,
  mergeGridPropControllerTranslatedData
} from "../prop-controllers/descriptors";
import { copy as propControllerCopy } from "../prop-controllers/copy";
import {
  RichTextControlType,
  copyRichTextData,
  richTextDTOtoDAO
} from "./rich-text";
import { richTextV2DescendentsToData } from "./rich-text-v2/dto";
import { copyRichTextV2Data } from "./rich-text-v2/copy";
import {
  RichTextV2ControlType,
  isRichTextV1Data
} from "./rich-text-v2/rich-text-v2";
import {
  getRichTextV2TranslatableData,
  mergeRichTextV2TranslatedData
} from "./rich-text-v2/translation";
function copy(definition, value, context) {
  switch (definition.type) {
    case Types.Backgrounds:
    case Types.Grid:
    case Types.NavigationLinks:
    case Types.Link:
    case Types.Shadows:
    case Types.Image:
    case Types.Images:
    case Types.ResponsiveColor:
    case Types.TableFormFields:
    case Types.Table:
    case Types.Border:
    case Types.RichText:
    case Types.ElementID:
      return propControllerCopy(definition, value, context);
    case RichTextControlType:
      return copyRichTextData(value, context);
    case RichTextV2ControlType:
      return copyRichTextV2Data(
        isRichTextV1Data(value) ? richTextV2DescendentsToData(richTextDTOtoDAO(value)) : value,
        context
      );
    case ColorControlType:
      return copyColorData(value, context);
    case ImageControlType:
      return copyImageData(value, context);
    case LinkControlType:
      return copyLinkData(value, context);
    case ShapeControlType:
      return copyShapeData(definition, value, context);
    case ListControlType:
      return copyListData(definition, value, context);
    case StyleControlType:
      return copyStyleData(value, context);
    case SlotControlType:
      return copySlotData(value, context);
    default:
      return value;
  }
}
function merge(definition, a, b = a, context) {
  switch (definition.type) {
    case SlotControlType:
      return mergeSlotData(a, b, context);
    default:
      return b;
  }
}
function getTranslatableData(definition, data) {
  switch (definition.type) {
    case Types.TextInput:
    case Types.TextArea:
    case TextInputControlType:
    case TextAreaControlType:
      return data;
    case RichTextV2ControlType:
      const richTextData = data;
      if (isRichTextV1Data(richTextData))
        return null;
      return getRichTextV2TranslatableData(definition, richTextData);
    case ListControlType:
      if (data == null)
        return null;
      return getListTranslatableData(definition, data);
    case ShapeControlType:
      if (data == null)
        return null;
      return getShapeTranslatableData(definition, data);
    default:
      return null;
  }
}
function mergeTranslatedData(definition, data, translatedData, context) {
  if (data == null)
    return data;
  switch (definition.type) {
    case Types.TextInput:
    case Types.TextArea:
    case TextInputControlType:
    case TextAreaControlType:
      if (translatedData == null)
        return data;
      return translatedData;
    case Types.Grid:
      return mergeGridPropControllerTranslatedData(data, context);
    case SlotControlType:
      return mergeSlotControlTranslatedData(data, context);
    case RichTextV2ControlType:
      if (translatedData == null)
        return data;
      return mergeRichTextV2TranslatedData(
        definition,
        data,
        translatedData
      );
    case ListControlType:
      if (translatedData == null)
        return data;
      return mergeListTranslatedData(
        definition,
        data,
        translatedData,
        context
      );
    case ShapeControlType:
      if (translatedData == null)
        return data;
      return mergeShapeTranslatedData(
        definition,
        data,
        translatedData,
        context
      );
    default:
      return data;
  }
}
export {
  copy,
  getTranslatableData,
  merge,
  mergeTranslatedData
};
//# sourceMappingURL=control.js.map